module.exports = __webpack_public_path__ + "static/media/guinea-bissau.6a5a27ff.png";